module.exports = __webpack_public_path__ + "static/media/ricardo-perez-logo.516229fd.svg";